import type { KeyboardEvent } from "react";

/** The parts of a keyboard event this reads. Narrower than the React type so tests need no cast. */
export type ActivationKeyEvent = Pick<
  KeyboardEvent<HTMLElement>,
  "key" | "repeat" | "preventDefault"
>;

/** Wraps a click handler so Enter and Space also trigger it on non-button elements. */
export const onKeyboardActivate =
  (handler: () => void) =>
  (event: ActivationKeyEvent): void => {
    if (event.repeat) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };
